import api from "./api";

export const getRoleAll = async () => {
    const response = await api.get(`role/listAll`);
    return response.data;
};